import { GatsbyBrowser } from "gatsby"
import React, { ReactNode } from "react"

import Page from "src/layout/page"

const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({ element }): ReactNode => <Page>{element}</Page>

export default wrapPageElement
